import { Component, OnInit, ViewChild } from '@angular/core';
import { RequestType, RequestTypeArray } from 'src/shared/models/request-type';
import { DataAggregatedOptionsComponent } from '../data-aggregated-options/data-aggregated-options.component';
import { AggregateOptionsComponent } from '../aggregate-options/aggregate-options.component';

@Component({
  selector: 'app-main-form',
  templateUrl: './main-form.component.html',
  styleUrls: ['./main-form.component.scss'],
})
export class MainFormComponent implements OnInit {
  public requestTypes = RequestTypeArray;
  public requestType: RequestType = 'AGGREGATED_VALUE';

  public dataAggregated: boolean = true;

  public multipleMetrics: boolean = false;
  public showEndDate: boolean = false;

  @ViewChild("dataAggregatedOptions")
  dataAggregatedOptions: DataAggregatedOptionsComponent;

  @ViewChild("aggregatedOptions")
  aggregatedOptions: AggregateOptionsComponent;

  constructor() { }

  ngOnInit(): void {
    this.onChangeType(this.requestType);
  }

  onChangeType($event: any) {
    this.aggregatedOptions?.reset();
    this.dataAggregatedOptions?.updateSettings(true);
    this.dataAggregated = $event === 'AGGREGATED_VALUE' || $event === 'AGGREGATED_VALUES';
    this.multipleMetrics = $event === 'LATEST' || $event !== 'INSTANT' || $event !== 'INSTANT_AFTER' || $event !== 'INSTANT_BEFORE';
    this.showEndDate = $event === 'RANGE' || $event === 'AGGREGATED_VALUE' || $event === 'AGGREGATED_VALUES' || $event === 'VALUES';
  }
}
